export const markName = 'inline-vote';
export const pluginKeyName = 'inlineVote';
